import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AddOutlined } from '@material-ui/icons';
import MessageCard from '../UI/MessageCard';
import { useInfiniteScroll } from './useInfiniteScroll';
import { graphqlOperation, API } from 'aws-amplify';
import { onUpdateUser } from '../../graphql/subscriptions';
import AddIdentityDialog from './AddIdentityDialog';
import { useStyles } from './styles';
import { Grid, Fab, Typography, CircularProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CardIdentity } from './CardIdentity';
import { setFilter, getIdentities, getMoreIdentities } from '../../actions';
import { connect } from 'react-redux';
import SearchToolbar from '../SearchToolbar';

// Tour
import { useTour } from '@reactour/tour';
import { tourSteps } from '../TourSteps';

const IdentityList = (props) => {
  const { setIsOpen, setCurrentStep, setSteps } = useTour();
  const classes = useStyles();
  const { identities, getAllIdentities, group } = props;
  const [loading, loadingMore, noMoreData] = useInfiniteScroll(props);
  const [openAddIdentityDialog, setOpenAddIdentityDialog] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const tour = JSON.parse(localStorage.getItem('tour-identity'));
    setSteps(tourSteps.createNewIdentity);
    setCurrentStep(0);
    setIsOpen(tour);
  }, []);

  useEffect(() => {
    const updateSubscription = API.graphql(
      graphqlOperation(onUpdateUser, { group })
    ).subscribe({
      next: () => {
        getAllIdentities();
      }
    });

    return () => {
      updateSubscription.unsubscribe();
    };
  }, []);

  if (openAddIdentityDialog) {
    return (
      <AddIdentityDialog
        open={openAddIdentityDialog}
        getAllIdentities={getAllIdentities}
        handleClose={() => setOpenAddIdentityDialog(false)}
      />
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.addBtn}>
        <Fab
          onClick={() => setOpenAddIdentityDialog(true)}
          className={classes.btn}
          aria-label='Add'
          color='primary'
        >
          <AddOutlined className='identity-newIdentity' />
        </Fab>
        {t('identityListView:addNewIdentity')}
      </div>
      <Grid container direction='column'>
        <SearchToolbar visibleFor={['/identity']} />
      </Grid>
      {identities && identities.length > 0 ? (
        <>
          {loading ? (
            <div style={{ textAlign: 'center', marginTop: 8, marginBottom: 30 }}>
              <CircularProgress />
            </div>
          ) : (
            <Grid container direction='column'>
              <Typography variant='body1' className={classes.title_identity}>
                {t('identityListView:lastIdentities')}
              </Typography>
              {identities.map((identity, i) =>
                <CardIdentity
                  key={i}
                  classes={classes}
                  identity={identity}
                  // getUsers={getUsers}
                  // getIdentities={getIdentities}
                  getAllIdentities={getAllIdentities}
                />
              )}
            </Grid>
          )}
          {loadingMore && (
            <div
              style={{
                textAlign: 'center',
                marginTop: 16,
                marginBottom: 8
              }}
            >
              <CircularProgress />
            </div>
          )}
          {noMoreData && (
            <div style={{ textAlign: 'center', marginTop: 8, marginBottom: 30 }}>
              <Typography variant='button'>
                {t('identityListView:noMoreData')}
              </Typography>
            </div>
          )}
        </>
      ) : loading ? (
        <div style={{ textAlign: 'center', marginTop: 8, marginBottom: 30 }}>
          <CircularProgress />
        </div>
      ) : (
        <MessageCard
          body={t('identityListView:noIdentity')}
          url='/identity/new'
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
    visibleTabs: state.config.visibleTabs,
    identities: state.identities.identities,
    group: state.config.group
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (data) => dispatch(setFilter(data)),
    getAllIdentities: () =>
      dispatch(getIdentities()),
    getMoreIdentities: (search) =>
      dispatch(getMoreIdentities(search))
  };
};

IdentityList.propTypes = {
  filter: PropTypes.object.isRequired,
  identities: PropTypes.array.isRequired,
  getAllIdentities: PropTypes.func.isRequired,
  group: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentityList);
